/* lib/api/unwrap.js — мост контракт-инверсии.
 * apiFetch резолвится в {ok,status,data} и НЕ бросает; UI прототипа ждёт fakeApi-контракт
 * (резолв payload / throw err{status,code,detail}). unwrap() восстанавливает throw-контракт,
 * чтобы useFakeQuery (read-seam) и catch-ветки мутаций (err.code/err.status) работали без правок. */

import { drfFieldError } from './drfErrors.js';

export async function unwrap(promise) {
  const { ok, status, data } = await promise;
  if (ok) return data;

  // DRF-валидация полей приходит БЕЗ detail/error: {<поле>: ["сообщение", …]}, {<поле>:
  // "сообщение"} (ValidationError из view/save()), список верхнего уровня, вложенные словари
  // (формы — drfErrors.js). Достаём первое сообщение и имя поля, чтобы экраны показывали
  // конкретную причину («ТТК #5 не найдена…») под нужным полем, а не общую «Ошибка запроса».
  let fieldName;
  let fieldMessage;
  if (data && typeof data === 'object' && !data.detail && !data.error) {
    const fe = drfFieldError(data, status);
    if (fe) {
      fieldMessage = fe.message;
      fieldName = fe.field;
    }
  }

  const e = new Error((data && (data.detail || data.error)) || fieldMessage || 'Ошибка запроса');
  e.status = status;
  if (data && typeof data === 'object') {
    if (data.code) e.code = data.code;
    // `detail` — то, что экраны печатают пользователю (`e?.detail || 'Ошибка'` — 68 мест).
    // DRF-валидация присылает {<поле>: [текст]} БЕЗ detail, и все эти экраны молча
    // показывали слово «Ошибка» вместо причины. Кладём сюда разобранное сообщение поля.
    // ВАЖНО: только настоящее сообщение сервера — generic-фоллбэк сюда НЕ пишем, иначе
    // экраны, у которых свой текст на пустой 403 (отчёты iiko), потеряют свою копию.
    if (data.detail) e.detail = data.detail;
    else if (fieldMessage) e.detail = fieldMessage;
    if (data.error) e.error = data.error; // напр. draft commit {error:'duplicate'}
    if (fieldName && data.field === undefined) e.field = fieldName;
    // прокидываем остальные информативные поля (usages_count, count, field…);
    // rows_count / used_in — 409 card_in_use (kitchen-ux D2-be: usages_count — число ТТК,
    // rows_count — строк состава, used_in — [{id, title}]);
    // committed_* — для W4 commit-guard 409 {code:'line_committed'} (план §18.4);
    // existing — 422 idempotency_key_reused: запись первой попытки (контракт idempotency-key,
    // lib/api/idempotency.js).
    for (const k of ['usages_count', 'rows_count', 'used_in', 'count', 'field',
                     'committed_version_n', 'committed_id', 'committed_kind', 'existing'])
      if (data[k] !== undefined) e[k] = data[k];
  }
  throw e;
}
